// extracted by mini-css-extract-plugin
module.exports = {"canIdentifyAndDelete":"AdditionalParty_canIdentifyAndDelete__1QXSF","deleteButton":"AdditionalParty_deleteButton__2Q0Ys","marginBotton":"AdditionalParty_marginBotton__7IYJi"};